const SET_CONFIG = 'SET_CONFIG';

export const setConfig = data => {
  return {
    type: SET_CONFIG,
    payload: data
  };
};


const defaultState = {
    debug: true,
    basePath: "http://verizon-digital-museum.s3.amazonaws.com/",
    apiPath: {
      digitalMuseum: "JSON/section/2",
      poweredByPurpose: "JSON/section/15",
      buildingBrigtherFutures: "JSON/section/35",
      verizonByTheNumbers:"JSON/section/176",
      communicationsChangeTheWorld: "JSON/section/214",
      global: "JSON/section/99"
    },
    apiMediaPath: "Images/",
    pollServer: {
      basePath: "",
      endPoint: ""
    }
};

const configReducer = (state = defaultState, action) => {
    switch (action.type) {
      case SET_CONFIG:
          if(action.payload.config){
              if(action.payload.config.debug !== null){
                  state.debug = action.payload.config.debug;
              }
              if(action.payload.config.basePath){
                  state.basePath = action.payload.config.basePath;
              }
              if(action.payload.config.apiPath){
                  state.apiPath = action.payload.config.apiPath;
              }
              if(action.payload.config.apiMediaPath){
                  state.apiMediaPath = action.payload.config.apiMediaPath;
              }
              if(action.payload.config.pollServer){
                  state.pollServer = action.payload.config.pollServer;
              }
          }
        return { ...state }
      default:
        return state;
    }
  };
  

export default configReducer;
